import moment from 'moment';
import * as api from '../api';
import { AppointmentDetails } from '../components/Chat/Conversation/Message/GeneralUi/Appointment';

export const isAppointmentCancellableNow = (
  appointment: AppointmentDetails,
): boolean => {
  const { isCancelEnabled, previsitConfirmCancelMinimumCancelTime } =
    appointment;
  if (!isCancelEnabled) return false;
  if (!previsitConfirmCancelMinimumCancelTime) return true;

  return moment()
    .add(
      previsitConfirmCancelMinimumCancelTime.time,
      api.PracticePreference.TimeUnitToMomentUnit[
        previsitConfirmCancelMinimumCancelTime.unit
      ],
    )
    .isBefore(appointment.startTime);
};

export const getCancelTimeWindow = (appointment: AppointmentDetails) => {
  const { previsitConfirmCancelMinimumCancelTime } = appointment;
  if (!previsitConfirmCancelMinimumCancelTime) return '';
  const { time, unit } = previsitConfirmCancelMinimumCancelTime;
  const formattedUnit = (time === 1 ? unit.slice(0, -1) : unit).toLowerCase();
  return `${time} ${formattedUnit}`;
};
